var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12V32C44 38.6274 38.6274 44 32 44H12C5.37258 44 0 38.6274 0 32V12Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 14H27.5C27.721 14 27.933 14.0808 28.0893 14.2246C28.2455 14.3685 28.3333 14.5636 28.3333 14.767V29.4494C28.3334 29.5179 28.3135 29.5853 28.2757 29.6444C28.238 29.7035 28.1836 29.7522 28.1185 29.7854C28.0533 29.8186 27.9796 29.8351 27.9051 29.8332C27.8306 29.8313 27.7581 29.811 27.695 29.7746L21.6667 26.2948L15.6383 29.7738C15.5753 29.8102 15.5028 29.8305 15.4284 29.8324C15.354 29.8343 15.2804 29.8179 15.2152 29.7848C15.1501 29.7517 15.0958 29.7031 15.0579 29.6441C15.02 29.5851 15.0001 29.5179 15 29.4494V14.767C15 14.5636 15.0878 14.3685 15.2441 14.2246C15.4004 14.0808 15.6123 14 15.8333 14ZM26.6667 15.534H16.6667V27.3701L21.6667 24.4854L26.6667 27.3701V15.534Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarks);
export default __webpack_public_path__ + "static/media/bookmarks.0d63397df9c7b33600895d1f3d41868b.svg";
export { ForwardRef as ReactComponent };